import Button from '@platform-ui/button-latest';
import cn from 'classnames';
import React from 'react';
import { PollSchema } from 'schema';
import ImageComponent from '../../../../components/Image';
import Markdown from '../../../../components/Markdown';
import { StickyFooterButton } from '../../../../components/StickyFooterButton';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';
import { inIframe } from '../../../../utils/location';
import { Title } from '../../Title';
import { ContentWrapper } from '../../Wrappers/ContentWrapper';
import { RootWrapper } from '../../Wrappers/RootWrapper';
import styles from './WelcomeMobileStories.module.css';

interface WelcomeMobileStoriesProps {
  title: string | null;
  welcome: PollSchema.WELCOME_MOBILE_STORIES['data'];
  onClick: () => void;
}

export const WelcomeMobileStories: React.FC<WelcomeMobileStoriesProps> = ({
  title: pollTitle,
  welcome: { image, imageTitle, imageDescription, title, text, cta, disclaimer },
  onClick,
}) => {
  const isPhone = useBreakpoint('phone');
  const buttonSize = isPhone ? 'l' : 'm';

  const hasImageTextContent = !!imageTitle || !!imageDescription;
  const hasTextContent = !!title || !!text;
  const showPollTitle = !!pollTitle && !inIframe();

  return (
    <div className={styles.container}>
      <RootWrapper className={styles.container}>
        {showPollTitle && <Title className={styles.pollTitle}>{pollTitle}</Title>}

        <ContentWrapper>
          {image && (
            <div className={styles.imageContainer}>
              <ImageComponent className={styles.image} image={image} />

              {hasImageTextContent && (
                <div className={styles.imageText}>
                  {imageTitle && (
                    <p className={cn(styles.imageTitle, { [c(styles.withSpacing)]: !!imageDescription })}>
                      {imageTitle}
                    </p>
                  )}
                  {imageDescription && <p className={styles.imageDescription}>{imageDescription}</p>}
                </div>
              )}
            </div>
          )}

          {hasTextContent && (
            <div className={cn({ [c(styles.withImage)]: !!image })}>
              {title && <Markdown className={styles.title}>{title}</Markdown>}

              {text && <Markdown className={styles.text}>{text}</Markdown>}
            </div>
          )}
        </ContentWrapper>

        <StickyFooterButton>
          <footer className={cn(styles.footer, { [c(styles.iframe)]: inIframe() })}>
            <div className={styles.ctaButton}>
              <Button onClick={onClick} size={buttonSize} wide={isPhone}>
                {cta}
              </Button>
            </div>

            {disclaimer && <Markdown className={styles.footerText}>{disclaimer}</Markdown>}
          </footer>
        </StickyFooterButton>
      </RootWrapper>
    </div>
  );
};
